// Interfaces
import { ICustomerInformation, IDesiredVehicleInformation, IProspectInformation } from "../../interfaces";

const INIT_CUSTOMER: ICustomerInformation = {
	type: "individual",
	firstInputName: "",
	secondInputName: "",
	thirdInputName: "",
	email: "",
	phones: [],
	preferredContactMethod: "",
	sendTextTo: "",
	emailConsent: "Null",
	textConsent: "Null",
	phoneConsent: "Null",
	sharePersonalInfoConsent: "Null",
	usePersonalInfoConsent: "Null",
	address: {
		address1: "",
		address2: "",
		city: "",
		state: "",
		country: "",
		zipCode: "",
	},
};

const INIT_PROSPECT: IProspectInformation = {
	bdcUser: "",
	businessUnitName: "",
	category: "",
	customerInitiated: false,
	manager: "",
	notes: "",
	providerName: "",
	providerService: "",
	salesPerson: "",
	secondarySalesPerson: "",
	status: "",
	statusType: "",
	type: "",
};

const INIT_VEHICLE: IDesiredVehicleInformation = {
	desiredVehicle: [],
	make: "",
	model: "",
	year: "",
	vin: "",
	odometer: "",
};

const INTERNET_TYPE = "Internet";

export { INIT_CUSTOMER, INIT_PROSPECT, INIT_VEHICLE, INTERNET_TYPE };
